import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function DefinirSenha() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null);

  useEffect(() => {
    if (!token) {
      setError("Link inválido.");
      setLoading(false);
      return;
    }
    api
      .get(`/client-onboarding/set-password/${token}`)
      .then(({ data }) => setInfo(data))
      .catch((err) => setError(err.response?.data?.detail || "Link inválido ou expirado."))
      .finally(() => setLoading(false));
  }, [token]);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (password.length < 8) {
      setError("A senha deve ter pelo menos 8 caracteres.");
      return;
    }
    if (password !== confirm) {
      setError("As senhas não conferem.");
      return;
    }
    setBusy(true);
    try {
      const { data } = await api.post("/client-onboarding/set-password", { token, password });
      setDone(data);
    } catch (err) {
      setError(err.response?.data?.detail || "Não foi possível definir a senha.");
    } finally {
      setBusy(false);
    }
  };

  const inputCls =
    "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-[#101652] outline-none focus:border-[#5b3bf0] focus:ring-4 focus:ring-[#5b3bf0]/10";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f5f6fb] px-6">
      <div className="w-full max-w-md rounded-[32px] border border-slate-200/80 bg-white p-8 shadow-[0_20px_60px_-30px_rgba(16,22,82,0.25)]">
        <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#5b3bf0]">Simpler</div>

        {loading && <p className="mt-6 text-sm text-slate-500">Carregando...</p>}

        {!loading && done && (
          <>
            <h1 className="mt-2 text-2xl font-bold tracking-[-0.03em] text-[#101652]">Senha criada!</h1>
            <p className="mt-2 text-sm text-slate-500">
              Agora é só entrar no portal do seu escritório com o e-mail <strong>{done.email}</strong> e a senha
              que você acabou de criar.
            </p>
            <a
              href={done.portal_url}
              className="mt-6 block rounded-2xl bg-[#101652] px-5 py-3 text-center text-sm font-bold text-white hover:opacity-90"
            >
              Acessar meu portal
            </a>
          </>
        )}

        {!loading && !done && info && (
          <form onSubmit={submit}>
            <h1 className="mt-2 text-2xl font-bold tracking-[-0.03em] text-[#101652]">Crie sua senha</h1>
            <p className="mt-2 text-sm text-slate-500">
              {info.organization ? <><strong>{info.organization}</strong> · </> : null}
              {info.email}
            </p>
            <div className="mt-6 grid gap-4">
              <input type="password" className={inputCls} placeholder="Nova senha (mínimo 8 caracteres)"
                value={password} onChange={(e) => setPassword(e.target.value)} autoFocus />
              <input type="password" className={inputCls} placeholder="Confirme a senha"
                value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            </div>
            {error && (
              <div className="mt-4 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">{error}</div>
            )}
            <button type="submit" disabled={busy}
              className="mt-6 w-full rounded-2xl bg-[#5b3bf0] px-5 py-3 text-sm font-bold text-white hover:opacity-90 disabled:opacity-50">
              {busy ? "Salvando..." : "Criar senha e acessar"}
            </button>
          </form>
        )}

        {!loading && !done && !info && (
          <>
            <h1 className="mt-2 text-2xl font-bold tracking-[-0.03em] text-[#101652]">Link indisponível</h1>
            <p className="mt-2 text-sm text-slate-500">{error}</p>
          </>
        )}
      </div>
    </div>
  );
}
